import { combineReducers } from "redux";
import padrao from "./padrao";

export default combineReducers({
  padrao,
});
